/**
 * @description Module header
 */

/* global bsBreakpoints */

(() => {
	const searchInput = document.querySelector(
		'.views-exposed-form .form-text'
	);
	searchInput.setAttribute('placeholder', 'Votre recherche');

	// Const menu
	const header = document.querySelector('[data-js-header]');
	const headerMenu = document.querySelector('[data-js-header-nav]');
	const headerMenuDesktop = document.querySelector(
		'[data-js-header-menu-desktop]'
	);
	const headerMenuRWD = document.querySelector('[data-js-header-menu-rwd]');
	const headerMenuToggle = document.querySelector(
		'[data-js-header-menu-toggle]'
	);

	// Const Li menu
	const expanded = document.querySelectorAll(
		'.expanded .header__menu__expanded'
	);

	const headerMenuPrevious = document.querySelectorAll(
		'[data-js-header-menu-previous]'
	);

	const body = document.querySelector('body');

	// FUNCTIONS

	// Affiche dynamiquement le titre du sous menu en mobile
	const navRWD = () => {
		expanded.forEach(function (btn) {
			btn.addEventListener('click', function () {
				const parent = btn.closest('li');
				// Sous menu actif
				const submenu = btn.nextElementSibling;
				// Récupérer et afficher le titre du sous menu actif
				const title = btn.previousElementSibling.text;

				submenu.children[0].children[1].innerHTML = title;

				parent.classList.toggle('active');
				submenu.classList.toggle('active');
			});
		});
	};

	// Affiche ou retire le titre du sous menu
	const goPrevious = function goPrevious() {
		headerMenuPrevious.forEach(function (prev) {
			const parent = prev.closest('.header__menu__submenu');
			prev.addEventListener('click', function () {
				// Retire le titre du sous-menu
				// eslint-disable-next-line no-unused-vars
				const submenutitle = prev.previousElementSibling;
				// submenutitle.parentNode.removeChild(submenutitle);
				// Remove le sous-menu actif
				parent.classList.remove('active');
			});
		});
	};

	// Comportement au scroll
	const scrollHeader = () => {
		// Gère le cas de la toolbar drupal
		const toolbar = document
			.querySelector('body')
			.classList.contains('user-logged-in');

		document.onscroll = () => {
			if (toolbar) {
				if (window.pageYOffset > 40) {
					header.classList.add('scrolled');
				} else {
					header.classList.remove('scrolled');
				}
			}
		};
		if (
			window.pageYOffset > 40 &&
			document.querySelector('main').offsetHeight > window.innerHeight
		) {
			header.classList.add('scrolled');
		} else {
			header.classList.remove('scrolled');
		}
	};

	// Permet de récupérer la position d'un élément
	function offset(el) {
		const rect = el.getBoundingClientRect();
		const scrollLeft =
			window.pageXOffset || document.documentElement.scrollLeft;
		const scrollTop =
			window.pageYOffset || document.documentElement.scrollTop;
		return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
	}

	// Change la couleur du triangle d'indication du menu en fonction de sa position
	// Utilisation de la fonction offset crééé juste au dessus
	const afterSwitch = () => {
		const menuItem = document.querySelectorAll('.leaf-lvl-1');
		const middle = window.innerWidth / 2;
		if (
			bsBreakpoints.detectBreakpoint() === 'xLarge' ||
			bsBreakpoints.detectBreakpoint() === 'large'
		) {
			menuItem.forEach((item) => {
				const itemPosition = offset(item);
				if (itemPosition.left < middle - 100) {
					item.classList.add('white-triangle');
				} else {
					item.classList.add('grey-triangle');
				}
			});
		}
	};

	// Menu responsive
	const menuRwd = () => {
		if (
			bsBreakpoints.detectBreakpoint() === 'xSmall' ||
			bsBreakpoints.detectBreakpoint() === 'small' ||
			bsBreakpoints.detectBreakpoint() === 'medium'
		) {
			headerMenuRWD.appendChild(headerMenu);
		}
		if (
			bsBreakpoints.detectBreakpoint() === 'xLarge' ||
			bsBreakpoints.detectBreakpoint() === 'large'
		) {
			headerMenuDesktop.appendChild(headerMenu);
		}
	};

	// Gère le déplacement du menu en fonction du périphérique
	const toggleMenu = function toggleMenu() {
		headerMenuToggle.addEventListener('click', function () {
			headerMenuRWD.appendChild(headerMenu);
			headerMenuToggle.classList.toggle('active');
			if(headerMenuToggle.getAttribute('aria-expanded') === 'true') {
				headerMenuToggle.setAttribute('aria-expanded', 'false');
			} else {
				headerMenuToggle.setAttribute('aria-expanded', 'true');
			}
			headerMenuRWD.classList.toggle('active');
			body.classList.toggle('fixed');
		});
	};

	// GO après chargement 🚀

	window.addEventListener('load', function () {
		if (document.body.contains(header)) {
			toggleMenu();
			navRWD();
			goPrevious();
			scrollHeader();
			afterSwitch();
		}
		window.onresize = function () {
			menuRwd();
		};
	});
})();
